export default __webpack_public_path__ + "static/media/Level14.6a221050.svg";